import { render, staticRenderFns } from "./TabelaCadastros.vue?vue&type=template&id=194884ed&scoped=true"
import script from "./TabelaCadastros.vue?vue&type=script&lang=js"
export * from "./TabelaCadastros.vue?vue&type=script&lang=js"
import style0 from "./TabelaCadastros.vue?vue&type=style&index=0&id=194884ed&prod&lang=css"
import style1 from "./TabelaCadastros.vue?vue&type=style&index=1&id=194884ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194884ed",
  null
  
)

export default component.exports